(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "e2e86ceea300f1a8dfc88cfcb8df96a61f6aa622"
};